import { asObject } from "../coerce";
import { mapApiItemsToCards } from "./contentCardMapper";
import type {
  FavoritesApiResponse,
  FavoritesContentData,
  PortalContentKind,
} from "../../../@types/portalAluno";

const FAVORITE_COLLECTIONS: Array<{
  key: keyof FavoritesApiResponse;
  sourceType: PortalContentKind;
}> = [
  { key: "conteudos", sourceType: "conteudos" },
  { key: "t1", sourceType: "treinamentos-de-1-ponto" },
  { key: "comunicados", sourceType: "comunicados" },
  { key: "cursos", sourceType: "cursos" },
  { key: "segurancaNoTrabalhos", sourceType: "seguranca-do-trabalho" },
  { key: "trilhas", sourceType: "trilhas" },
];

export const mapFavoritesResponse = (value: unknown): FavoritesContentData => {
  const response = asObject<FavoritesApiResponse>(value);
  if (!response) {
    throw new Error("A API retornou uma lista de favoritos inválida.");
  }

  return {
    cards: FAVORITE_COLLECTIONS.flatMap(({ key, sourceType }) =>
      mapApiItemsToCards(response[key], sourceType)
    ),
  };
};
